import { Routes } from '@angular/router';
import {
  AttachmentDataComponentConfig,
  AttachmentsDataSectionComponent
} from '../common/attachments-data-section/attachments-data-section.component';
import {
  ApplicantDataSectionComponent,
  ApplicantDataComponentConfig
} from '../common/applicant-data-section/applicant-data-section.component';
import {
  ApplicationDataSectionComponent,
  ApplicationDataComponentConfig
} from '../common/application-data-section/application-data-section.component';
import {
  AgreementsDataSectionComponent,
  AgreementsDataComponentConfig
} from '../common/agreements-data-section/agreements-data-section.component';
import {
  OccupationDataComponentConfig,
  OccupationDataSectionComponent
} from '../common/occupation-data-section/occupation-data-section.component';
import {
  ContractorDataComponentConfig,
  ContractorDataSectionComponent
} from '../common/contractor-data-section/contractor-data-section.component';
import {
  PaymentsDataComponentConfig,
  PaymentsDataSectionComponent
} from '../common/payments-data-section/payments-data-section.component';

export const stages = [
  'Wnioskodawca',
  'Dane wniosku',
  'Inwestor',
  'Zajęcia',
  'Prognozowane opłaty',
  'Zgody',
  'Załączniki'
];

export const applicantDataSectionConfig: ApplicantDataComponentConfig = {
  stages
};

export const applicationDataSectionConfig: ApplicationDataComponentConfig = {
  stages,
  successUrl: '../wykonawca',
  cancelUrl: '../wnioskodawca',
  addManagerForm: true,
  addRoadTrafficImpactControl: true
};

export const contractorDataSectionConfig: ContractorDataComponentConfig = {
  stages,
  cancelUrl: '../dane-wniosku',
  successUrl: '../dane-zajecia',
  customTitles: {
    sectionTitle: 'Inwestor',
    dataSameAsApplicantLabels: {
      rejectLabel: 'Chcę wprowadzić dane inwestora',
      acceptLabel: 'Dane inwestora są takie same jak dane wnioskodawcy'
    },
    cardTitle: 'Dodanie inwestora',
    addBtnTitle: 'Dodaj inwestora',
    addBtn2Title: 'Dodaj kolejnego inwestora',
    noDataInfo: 'Brak dodanych inwestorów!'
  }
};

export const occupationDataSectionConfig: OccupationDataComponentConfig = {
  stages,
  addDecisionControls: true,
  hidePurposeControl: true,
  hideOccupationTypeControl: true,
  hideCityControl: true,
  addWorkPurposeControl: true,
  workPurposeControlType: 'textarea',
  cancelUrl: '../wykonawca',
  successUrl: '../oplaty'
};

export const paymentsDataSectionConfig: PaymentsDataComponentConfig = {
  stages,
  successUrl: '../zgody',
  cancelUrl: '../dane-zajecia'
};

export const agreementsDataSectionConfig: AgreementsDataComponentConfig = {
  stages,
  cancelUrl: '../oplaty',
  successUrl: '../zalaczniki'
};

export const attachmentDataSectionConfig: AttachmentDataComponentConfig = {
  stages,
  cancelUrl: '../zgody'
};

export const carryingOutWorksRoutes: Routes = [
  {
    component: ApplicantDataSectionComponent,
    path: 'wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicantDataSectionComponent,
    path: ':appId/wnioskodawca',
    data: applicantDataSectionConfig
  },
  {
    component: ApplicationDataSectionComponent,
    path: ':appId/dane-wniosku',
    data: applicationDataSectionConfig
  },
  {
    component: ContractorDataSectionComponent,
    path: ':appId/wykonawca',
    data: contractorDataSectionConfig
  },
  {
    component: OccupationDataSectionComponent,
    path: ':appId/dane-zajecia',
    data: occupationDataSectionConfig
  },
  {
    component: PaymentsDataSectionComponent,
    path: ':appId/oplaty',
    data: paymentsDataSectionConfig
  },
  {
    component: AgreementsDataSectionComponent,
    path: ':appId/zgody',
    data: agreementsDataSectionConfig
  },
  {
    component: AttachmentsDataSectionComponent,
    path: ':appId/zalaczniki',
    data: attachmentDataSectionConfig
  },
  { path: '', redirectTo: 'wnioskodawca', pathMatch: 'prefix' }
];
